module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Light.9d454558.eot";